import { Pipe, PipeTransform } from '@angular/core';
import { isEmpty } from 'lodash';

@Pipe({ name: 'NewsletterHtml' })
export class NewsletterHtmlPipe implements PipeTransform {
  LOREM_IPSUM =
    'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nam eu hendrerit dui, nec laoreet dolor. Morbi nec metus ac nibh egestas imperdiet dapibus ut nunc. Proin molestie dui ut nulla auctor commodo. Nulla viverra ligula at lectus lacinia pulvinar. Proin laoreet in purus ut consectetur. Vestibulum ac malesuada dui, id dignissim eros. Maecenas nulla lectus, suscipit vel odio quis, vulputate viverra quam. Sed eleifend facilisis quam, et pretium nibh consequat nec. Vestibulum tincidunt, sapien pharetra tempus iaculis, augue nibh venenatis nisl, et laoreet erat tortor et lectus. In hac habitasse platea dictumst. Pellentesque at sagittis lorem. Aliquam volutpat nulla commodo turpis dapibus pulvinar. Mauris ullamcorper mi ut ultricies sodales. Curabitur in nulla in massa posuere bibendum id eget ipsum. Cras sollicitudin efficitur malesuada.\n' +
    '\n' +
    'Proin vel tellus venenatis, malesuada quam ac, pellentesque arcu. Integer eleifend porttitor nisl, a blandit ex posuere a. Aliquam non sollicitudin massa, ac lobortis elit. Phasellus blandit libero quis metus tempus congue. Vivamus blandit, nunc sed molestie viverra, leo erat sodales metus, id tincidunt turpis tellus vitae ex. Aenean dignissim magna ut pellentesque posuere. Maecenas lorem tellus, varius id pellentesque et, blandit laoreet ante. Vestibulum vestibulum orci ultricies tortor ornare, a fermentum nisl sollicitudin. Curabitur aliquam non libero non facilisis. Vestibulum aliquet ac magna sit amet feugiat.';

  /**
   * Pipe filters the list of rooms-chat based on the search text provided
   *
   * @returns Return valid content for Newsletter
   * @param content
   * @param key
   * @param headless
   * @param isTitleInd
   * @param limit
   * @param isCaptionInd
   */
  // transform(content: any|null, ): string | null {
  transform(
    content: any = {},
    key: string,
    headless = false,
    isTitleInd = true,
    limit = 100,
    isCaptionInd = false
  ): string {
    // For Viewing
    if (!headless) {
      if (isEmpty(content[key]) && isTitleInd) {
        return '<strong>Insert Title Here</strong>';
      } else if (isEmpty(content[key]) && !isTitleInd && isCaptionInd) {
        return `<p><span style="font-size:10.67px">${this.LOREM_IPSUM.substring(
          0,
          limit
        )}</span></p>`;
      } else if (isEmpty(content[key]) && !isTitleInd) {
        return this.LOREM_IPSUM.substring(0, limit);
      }
      return content[key];
    } else {
      // For Printing
      if (isEmpty(content[key])) {
        return '';
      }
      // If contains dummy data, return empty string
      //remove html tags
      const plainText = content[key].replace(/<[^>]*>?/gm, '');
      const terms = ['Insert Title Here', 'Lorem ipsum', 'Click to add text'];
      const result = terms.some(term => plainText.includes(term));
      if (result) {
        return '';
      } else {
        return content[key];
      }
    }
  }
}
